var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientProfileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "patient-profile-image",
    transform: "translate(-360 -299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 213,
    height: 213,
    rx: 10,
    transform: "translate(360 299)",
    fill: "#ebf7fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "patients",
    transform: "translate(408.451 347.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M0,0H117.013V117.013H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M4,103.386a39,39,0,1,1,78.009,0H72.258a29.253,29.253,0,1,0-58.506,0Zm39-43.88A29.253,29.253,0,1,1,72.258,30.253,29.245,29.245,0,0,1,43,59.506Zm0-9.751a19.5,19.5,0,1,0-19.5-19.5A19.5,19.5,0,0,0,43,49.755Z",
    transform: "translate(15.502 3.876)",
    fill: "#09c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientProfileImage);
export default __webpack_public_path__ + "static/media/patient-profile-image.45ce134741f5ef184543bc4cd4affd27.svg";
export { ForwardRef as ReactComponent };